import tasksListQuery, { tasksByWeeks } from '../../../api-v2/queries/tasks-list-query';

export const myTasksDashboardLoader = (queryClient, user) => async () => {
  const baseFilters = { user: user.id };
  const nowFilters = { ...baseFilters, status: 'due_overdue' };
  const nextFilters = { ...baseFilters, status: 'ongoing' };
  const laterFilters = { ...baseFilters, status: 'scheduled' };
  const page = 1;
  const pageSize = 10;
  const sort = 'endDate:asc';

  queryClient.ensureQueryData(tasksListQuery({ page, pageSize, filters: nowFilters, sort }));
  queryClient.ensureQueryData(tasksListQuery({ page, pageSize, filters: nextFilters, sort }));
  queryClient.ensureQueryData(tasksListQuery({ page, pageSize, filters: laterFilters, sort }));
  queryClient.ensureQueryData(tasksByWeeks());

  return {
    user: user.id,
    page,
    pageSize,
    sort,
    nowFilters,
    nextFilters,
    laterFilters,
  };
};
